
// // import React, { useState } from 'react';
// // import apiService from '../Service/apiService';
// // import './Promotions.css';

// // const Promotions = ({ onLoginSuccess }) => {
// //     const [deviceId, setDeviceId] = useState('');
// //     const [password, setPassword] = useState('');
// //     const [loading, setLoading] = useState(false);
// //     const [error, setError] = useState('');

// //     const handleSubmit = async (e) => {
// //         e.preventDefault();
// //         setLoading(true);
// //         setError('');

// //         try {
// //             const data = await apiService.getScreenData(deviceId, password);
// //             onLoginSuccess(data, deviceId, password);
// //         } catch (err) {
// //             console.error('Login error in component:', err); // Add this
// //             setError(apiService.formatErrorMessage(err));
// //         } finally {
// //             setLoading(false);
// //         }
// //     };

// //     return (
// //         <div className="promotions-container">
// //             {/* Animated background elements */}
// //             <div className="circle circle-1"></div>
// //             <div className="circle circle-2"></div>
// //             <div className="circle circle-3"></div>

// //             <div className="login-box">
// //                 {/* Logo/Brand Section */}
// //                 <div className="brand-section">
// //                     <div className="logo-wrapper">
// //                         <svg className="logo-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
// //                             <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
// //                             <path d="M2 17L12 22L22 17" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
// //                             <path d="M2 12L12 17L22 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
// //                         </svg>
// //                     </div>
// //                     <h1 className="brand-name">Maamaa's<span> Promotions</span></h1>
// //                 </div>

// //                 <div className="login-header">
// //                     <h2>Welcome Back</h2>
// //                     <p>Enter your device credentials to access the Screen</p>
// //                 </div>

// //                 <form onSubmit={handleSubmit} className="login-form">
// //                     <div className="input-wrapper">
// //                         <div className="input-icon">
// //                             <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
// //                                 <path d="M20 21V19C20 16.7909 18.2091 15 16 15H8C5.79086 15 4 16.7909 4 19V21" stroke="#e66d33" strokeWidth="2" strokeLinecap="round" />
// //                                 <circle cx="12" cy="7" r="4" stroke="#e66d33" strokeWidth="2" />
// //                             </svg>
// //                         </div>
// //                         <div className="input-group">
// //                             <input
// //                                 type="text"
// //                                 id="deviceId"
// //                                 value={deviceId}
// //                                 onChange={(e) => setDeviceId(e.target.value)}
// //                                 placeholder="Enter your device ID"
// //                                 required
// //                                 disabled={loading}
// //                                 className={error ? 'error' : ''}
// //                             />
// //                         </div>
// //                     </div>

// //                     <div className="input-wrapper">
// //                         <div className="input-icon">
// //                             <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
// //                                 <rect x="3" y="11" width="18" height="11" rx="2" ry="2" stroke="#e66d33" strokeWidth="2" />
// //                                 <path d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11" stroke="#e66d33" strokeWidth="2" />
// //                             </svg>
// //                         </div>
// //                         <div className="input-group">
// //                             <input
// //                                 type="password"
// //                                 id="password"
// //                                 value={password}
// //                                 onChange={(e) => setPassword(e.target.value)}
// //                                 placeholder="Enter your password"
// //                                 required
// //                                 disabled={loading}
// //                                 className={error ? 'error' : ''}
// //                             />
// //                         </div>
// //                     </div>

// //                     {error && (
// //                         <div className="error-message">
// //                             <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
// //                                 <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
// //                                 <line x1="12" y1="8" x2="12" y2="12" stroke="currentColor" strokeWidth="2" />
// //                                 <circle cx="12" cy="16" r="1" fill="currentColor" />
// //                             </svg>
// //                             <span>{error}</span>
// //                         </div>
// //                     )}

// //                     <button
// //                         type="submit"
// //                         className={`login-button ${loading ? 'loading' : ''}`}
// //                         disabled={loading}
// //                     >
// //                         {loading ? (
// //                             <>
// //                                 <span className="spinner"></span>
// //                                 Authenticating...
// //                             </>
// //                         ) : (
// //                             'Login'
// //                         )}
// //                     </button>
// //                 </form>
// //             </div>
// //         </div>
// //     );
// // };

// // export default Promotions;




// import React, { useState } from 'react';
// import apiService from '../Service/apiService';
// import './Promotions.css';

// const Promotions = ({ onLoginSuccess }) => {
//     const [deviceId, setDeviceId] = useState('');
//     const [password, setPassword] = useState('');
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState('');
//     const [showPassword, setShowPassword] = useState(false); // New state for password visibility

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setLoading(true);
//         setError('');

//         try {
//             const data = await apiService.getScreenData(deviceId, password);
//             onLoginSuccess(data, deviceId, password);
//         } catch (err) {
//             console.error('Login error in component:', err);
//             setError(apiService.formatErrorMessage(err));
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Toggle password visibility
//     const togglePasswordVisibility = () => {
//         setShowPassword(!showPassword);
//     };

//     return (
//         <div className="promotions-container">
//             {/* Animated background elements */}
//             <div className="circle circle-1"></div>
//             <div className="circle circle-2"></div>
//             <div className="circle circle-3"></div>

//             <div className="login-box">
//                 {/* Logo/Brand Section */}
//                 <div className="brand-section">
//                     <div className="logo-wrapper">
//                         <svg className="logo-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                             <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//                             <path d="M2 17L12 22L22 17" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//                             <path d="M2 12L12 17L22 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//                         </svg>
//                     </div>
//                     <h1 className="brand-name">Maamaa's<span> Promotions</span></h1>
//                 </div>

//                 <div className="login-header">
//                     <h2>Welcome Back</h2>
//                     <p>Enter your device credentials to access the Screen</p>
//                 </div>

//                 <form onSubmit={handleSubmit} className="login-form">
//                     <div className="input-wrapper">
//                         <div className="input-icon">
//                             <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                                 <path d="M20 21V19C20 16.7909 18.2091 15 16 15H8C5.79086 15 4 16.7909 4 19V21" stroke="#e66d33" strokeWidth="2" strokeLinecap="round" />
//                                 <circle cx="12" cy="7" r="4" stroke="#e66d33" strokeWidth="2" />
//                             </svg>
//                         </div>
//                         <div className="input-group">
//                             <input
//                                 type="text"
//                                 id="deviceId"
//                                 value={deviceId}
//                                 onChange={(e) => setDeviceId(e.target.value)}
//                                 placeholder="Enter your device ID"
//                                 required
//                                 disabled={loading}
//                                 className={error ? 'error' : ''}
//                             />
//                         </div>
//                     </div>

//                     <div className="input-wrapper password-wrapper">
//                         <div className="input-icon">
//                             <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                                 <rect x="3" y="11" width="18" height="11" rx="2" ry="2" stroke="#e66d33" strokeWidth="2" />
//                                 <path d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11" stroke="#e66d33" strokeWidth="2" />
//                             </svg>
//                         </div>
//                         <div className="input-group password-input-group">
//                             <input
//                                 type={showPassword ? "text" : "password"}
//                                 id="password"
//                                 value={password}
//                                 onChange={(e) => setPassword(e.target.value)}
//                                 placeholder="Enter your password"
//                                 required
//                                 disabled={loading}
//                                 className={error ? 'error' : ''}
//                             />
//                             <button
//                                 type="button"
//                                 className="password-toggle-btn"
//                                 onClick={togglePasswordVisibility}
//                                 tabIndex="-1"
//                             >
//                                 {showPassword ? (
//                                     <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                                         <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" stroke="#e66d33" strokeWidth="2" />
//                                         <circle cx="12" cy="12" r="3" fill="#e66d33" />
//                                     </svg>
//                                 ) : (
//                                     <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                                         <path d="M2 2L22 22" stroke="#e66d33" strokeWidth="2" strokeLinecap="round" />
//                                         <path d="M6.71277 6.7226C3.66479 8.79527 2 12 2 12C2 12 5.63636 19 12 19C14.0503 19 15.8174 18.2734 17.2711 17.2764" stroke="#e66d33" strokeWidth="2" strokeLinecap="round" />
//                                         <path d="M10.7426 10.7617C9.90859 11.6022 9.90859 12.9828 10.7426 13.8233C11.5766 14.6638 12.9468 14.6638 13.7808 13.8233" stroke="#e66d33" strokeWidth="2" strokeLinecap="round" />
//                                         <path d="M21 12C21 12 20.5 13 19.5 14.5" stroke="#e66d33" strokeWidth="2" strokeLinecap="round" />
//                                         <path d="M17 8C17 8 18.5 9.5 19.5 11" stroke="#e66d33" strokeWidth="2" strokeLinecap="round" />
//                                     </svg>
//                                 )}
//                             </button>
//                         </div>
//                     </div>

//                     {error && (
//                         <div className="error-message">
//                             <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                                 <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
//                                 <line x1="12" y1="8" x2="12" y2="12" stroke="currentColor" strokeWidth="2" />
//                                 <circle cx="12" cy="16" r="1" fill="currentColor" />
//                             </svg>
//                             <span>{error}</span>
//                         </div>
//                     )}

//                     <button
//                         type="submit"
//                         className={`login-button ${loading ? 'loading' : ''}`}
//                         disabled={loading}
//                     >
//                         {loading ? (
//                             <>
//                                 <span className="spinner"></span>
//                                 Authenticating...
//                             </>
//                         ) : (
//                             'Login'
//                         )}
//                     </button>
//                 </form>
//             </div>
//         </div>
//     );
// };

// export default Promotions;




import React, { useState } from 'react';
import apiService from '../Service/apiService';
import './Promotions.css';

const Promotions = ({ onLoginSuccess }) => {
    const [deviceId, setDeviceId] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [validationErrors, setValidationErrors] = useState({});

    // Frontend validation function
    const validateForm = () => {
        const errors = {};
        
        if (!deviceId.trim()) {
            errors.deviceId = 'Device ID is required';
        } else if (deviceId.length < 5) {
            errors.deviceId = 'Device ID must be at least 5 characters';
        }

        if (!password.trim()) {
            errors.password = 'Password is required';
        } else if (password.length < 4) {
            errors.password = 'Password must be at least 4 characters';
        }

        setValidationErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        
        if (!validateForm()) {
            return;
        }

        setLoading(true);

        try {
            const data = await apiService.getScreenData(deviceId, password);
            onLoginSuccess(data, deviceId, password);
        } catch (err) {
            console.error('Login error:', err);
            
            // User-friendly error messages
            if (err.message === 'Failed to fetch') {
                setError('Unable to connect to server. Please check your internet connection.');
            } 
            else if (err.message.includes('Invalid device ID or password')) {
                setError('The device ID or password you entered is incorrect. Please try again.');
            }
            else if (err.message.includes('not found')) {
                setError('Device not found. Please check your Device ID.');
            }
            else if (err.message.includes('NetworkError')) {
                setError('Network error. Please check your connection and try again.');
            }
            else {
                // For any other error, show a generic message
                setError('Login failed. Please check your credentials and try again.');
            }
        } finally {
            setLoading(false);
        }
    };

    const handleDeviceIdChange = (e) => {
        setDeviceId(e.target.value);
        if (validationErrors.deviceId) {
            setValidationErrors(prev => ({ ...prev, deviceId: '' }));
        }
        if (error) setError('');
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
        if (validationErrors.password) {
            setValidationErrors(prev => ({ ...prev, password: '' }));
        }
        if (error) setError('');
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div className="promotions-container">
            <div className="circle circle-1"></div>
            <div className="circle circle-2"></div>
            <div className="circle circle-3"></div>

            <div className="login-box">
                <div className="brand-section">
                    <div className="logo-wrapper">
                        <svg className="logo-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M2 17L12 22L22 17" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M2 12L12 17L22 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                    <h1 className="brand-name">Maamaa's<span> Promotions</span></h1>
                </div>

                <div className="login-header">
                    <h2>Welcome Back</h2>
                    <p>Enter your device credentials to access the Screen</p>
                </div>

                <form onSubmit={handleSubmit} className="login-form">
                    <div className="input-wrapper">
                        <div className="input-icon">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20 21V19C20 16.7909 18.2091 15 16 15H8C5.79086 15 4 16.7909 4 19V21" stroke="#e66d33" strokeWidth="2" strokeLinecap="round" />
                                <circle cx="12" cy="7" r="4" stroke="#e66d33" strokeWidth="2" />
                            </svg>
                        </div>
                        <div className="input-group">
                            <input
                                type="text"
                                id="deviceId"
                                value={deviceId}
                                onChange={handleDeviceIdChange}
                                placeholder="Enter your device ID"
                                required
                                disabled={loading}
                                className={validationErrors.deviceId || error ? 'error' : ''}
                            />
                            {validationErrors.deviceId && (
                                <div className="field-error-message">
                                    {validationErrors.deviceId}
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="input-wrapper password-wrapper">
                        <div className="input-icon">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" stroke="#e66d33" strokeWidth="2" />
                                <path d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11" stroke="#e66d33" strokeWidth="2" />
                            </svg>
                        </div>
                        <div className="input-group password-input-group">
                            <input
                                type={showPassword ? "text" : "password"}
                                id="password"
                                value={password}
                                onChange={handlePasswordChange}
                                placeholder="Enter your password"
                                required
                                disabled={loading}
                                className={validationErrors.password || error ? 'error' : ''}
                            />
                            <button
                                type="button"
                                className="password-toggle-btn"
                                onClick={togglePasswordVisibility}
                                tabIndex="-1"
                            >
                                {showPassword ? (
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" stroke="#e66d33" strokeWidth="2" />
                                        <circle cx="12" cy="12" r="3" fill="#e66d33" />
                                    </svg>
                                ) : (
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2 2L22 22" stroke="#e66d33" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M6.71277 6.7226C3.66479 8.79527 2 12 2 12C2 12 5.63636 19 12 19C14.0503 19 15.8174 18.2734 17.2711 17.2764" stroke="#e66d33" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M10.7426 10.7617C9.90859 11.6022 9.90859 12.9828 10.7426 13.8233C11.5766 14.6638 12.9468 14.6638 13.7808 13.8233" stroke="#e66d33" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M21 12C21 12 20.5 13 19.5 14.5" stroke="#e66d33" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M17 8C17 8 18.5 9.5 19.5 11" stroke="#e66d33" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                )}
                            </button>
                            {validationErrors.password && (
                                <div className="field-error-message">
                                    {validationErrors.password}
                                </div>
                            )}
                        </div>
                    </div>

                    {/* User-friendly error message */}
                    {error && (
                        <div className="error-message">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                                <line x1="12" y1="8" x2="12" y2="12" stroke="currentColor" strokeWidth="2" />
                                <circle cx="12" cy="16" r="1" fill="currentColor" />
                            </svg>
                            <span>{error}</span>
                        </div>
                    )}

                    <button
                        type="submit"
                        className={`login-button ${loading ? 'loading' : ''}`}
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <span className="spinner"></span>
                                Authenticating...
                            </>
                        ) : (
                            'Login'
                        )}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Promotions;